const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Вы могли подумать, что пламя красного дракона выжжет любые гигиенические проблемы в пасти и поэтому его дыхание будет свежим, как весенние цветы. Вы ошибаетесь`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
